import {BehaviorSubject} from "rxjs";
import {hookFromSubject, promiseToSubject, ResponseSubjectState} from "./index";
import {ClassifierApi, Configuration} from "../generated-api";
import { getCustomHeaders } from "./user";

const {REACT_APP_API_DOMAIN} = process.env;
const classifierApi = new ClassifierApi(new Configuration({basePath: REACT_APP_API_DOMAIN, getHeaders: getCustomHeaders}));

export const classifierCountriesSubject = new BehaviorSubject(new ResponseSubjectState());
export const useCountriesClassifier = hookFromSubject(classifierCountriesSubject);
export const getClassifierCountries = () =>
    promiseToSubject(classifierApi.apiClassifierCountriesGet(), classifierCountriesSubject);
